import { SelectorOption } from "../../../components/Redux/BasicSelector";

export const DnsLookupFamilyOptions: SelectorOption[] = [
  { label: "Auto", id: "AUTO" },
  { label: "V4 Only", id: "V4_ONLY" },
  { label: "V6 Only", id: "V6_ONLY" },
  { label: "V4 Preferred", id: "V4_PREFERRED" },
  { label: "All", id: "ALL" },
];
